import { API_BASE_URL, apiCall, getUser } from "./client";
import { getCookieConsent } from "@/lib/cookieConsent";
import { allowsOptionalTracking } from "@/lib/accountCompliance";

function getAdTrackingConsent() {
  const userId = getUser()?.id;
  if (!allowsOptionalTracking(userId)) return "necessary";
  return getCookieConsent() || "necessary";
}

function buildQuery(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    search.set(key, value);
  });
  const query = search.toString();
  return query ? `?${query}` : "";
}

export const listAds = () => apiCall("/api/ads", { method: "GET" });
export const getAdsOverview = (params = {}) => apiCall(`/api/ads/overview${buildQuery(params)}`, { method: "GET" });
export const getAdCustomerDetail = (customerName, params = {}) =>
  apiCall(`/api/ads/customers/${encodeURIComponent(customerName)}${buildQuery(params)}`, { method: "GET" });
export const getAd = (id) => apiCall(`/api/ads/${id}`, { method: "GET" });
export const createAd = (data) =>
  apiCall("/api/ads", {
    method: "POST",
    body: JSON.stringify(data),
  });
export const updateAd = (id, data) =>
  apiCall(`/api/ads/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
export const deleteAd = (id) => apiCall(`/api/ads/${id}`, { method: "DELETE" });
export const approveAd = (id) => apiCall(`/api/ads/${id}/approve`, { method: "POST" });
export const rejectAd = (id) => apiCall(`/api/ads/${id}/reject`, { method: "POST" });
export const pauseAd = (id) => apiCall(`/api/ads/${id}/pause`, { method: "POST" });
export const activateAd = (id) => apiCall(`/api/ads/${id}/activate`, { method: "POST" });
export const selectAd = (payload) =>
  apiCall("/api/ads/select", {
    method: "POST",
    headers: {
      "X-Cookie-Consent": getAdTrackingConsent(),
    },
    body: JSON.stringify(payload),
  });

export function buildAdVisitUrl(ad, placement = "banner", slotKey = "default") {
  if (!ad?.id) return ad?.click_url || "#";
  const encodedPlacement = encodeURIComponent(placement || ad?.placement || "banner");
  const encodedSlotKey = encodeURIComponent(slotKey || ad?.slot_key || "default");
  const encodedConsent = encodeURIComponent(getAdTrackingConsent());
  const defaultVisitPath = `/api/ads/${ad.id}/visit?placement=${encodedPlacement}&slotKey=${encodedSlotKey}&consent=${encodedConsent}`;
  const visitPath = ad.visit_url
    ? `${ad.visit_url}${ad.visit_url.includes("?") ? "&" : "?"}slotKey=${encodedSlotKey}&consent=${encodedConsent}`
    : defaultVisitPath;
  if (visitPath.startsWith("http")) return visitPath;
  const base = (API_BASE_URL || "").replace(/\/$/, "");
  return `${base}${visitPath}`;
}
